import './App.css';

const phoneShot = `${process.env.PUBLIC_URL}/assets/zwacop-phone.png`;
const providerShot = `${process.env.PUBLIC_URL}/assets/zwacop-provider-profile.png`;
const certifiedBadgeShot = `${process.env.PUBLIC_URL}/assets/zwacop-certified-badge.jpg`;
const appIcon = `${process.env.PUBLIC_URL}/assets/zwacop-icon.png`;
const clientSearchImage = `${process.env.PUBLIC_URL}/assets/zwacop-client-service-search.png`;
const connectedProvidersImage = `${process.env.PUBLIC_URL}/assets/zwacop-connected-providers.png`;
const urbanImpactImage = `${process.env.PUBLIC_URL}/assets/zwacop-urban-impact.png`;
const serviceHomeRepairImage = `${process.env.PUBLIC_URL}/assets/service-home-repair.png`;
const serviceTransportImage = `${process.env.PUBLIC_URL}/assets/service-transport-delivery.png`;
const serviceBeautyImage = `${process.env.PUBLIC_URL}/assets/service-beauty-wellness.png`;
const serviceProfessionalImage = `${process.env.PUBLIC_URL}/assets/service-professional.png`;
const mobileAppImage = `${process.env.PUBLIC_URL}/assets/zwacop-chat-screen.png`;
const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.app.mt&pcampaignid=web_share';
const appStoreUrl = 'https://apps.apple.com/cd/app/optacademia/id6449708415?l=fr-FR';

const steps = [
  {
    number: '01',
    icon: 'bi-search',
    title: 'Recherchez',
    text: 'Choisissez le service dont vous avez besoin.',
  },
  {
    number: '02',
    icon: 'bi-geo-alt',
    title: 'Trouvez',
    text: 'Découvrez les prestataires disponibles selon votre localisation.',
  },
  {
    number: '03',
    icon: 'bi-chat-dots',
    title: 'Contactez',
    text: 'Envoyez votre demande et échangez directement avec le professionnel.',
  },
];

const clientHighlights = [
  ['Prestataires proches', 'bi-geo-alt', 'Trouvez un professionnel fiable dans votre commune, sans appels inutiles.'],
  ['Profils clairs', 'bi-person-badge', 'Consultez les compétences, les disponibilités, les avis et les informations utiles.'],
  ['Échange direct', 'bi-chat-dots', 'Discutez avec le prestataire avant de confirmer votre demande de service.'],
  ['Gain de temps', 'bi-clock-history', 'Centralisez vos recherches et sécurisez vos demandes depuis votre téléphone.'],
];

const providerHighlights = [
  ['Plus de clients', 'bi-people', 'Recevez des demandes de particuliers, ménages, entreprises et institutions.'],
  ['Profil professionnel', 'bi-person-vcard', 'Présentez vos services, votre zone d’intervention et vos disponibilités.'],
  ['Demandes organisées', 'bi-inbox', 'Suivez les opportunités depuis une interface simple et pensée pour le terrain.'],
  ['Revenus digitaux', 'bi-graph-up-arrow', 'Développez votre activité grâce à une présence mobile accessible à Kinshasa et en RDC.'],
];

const clientFlow = [
  ['1', 'Recherche', 'Plomberie, nettoyage, informatique...'],
  ['2', 'Compare', 'Profils, avis, disponibilité'],
  ['3', 'Contacte', 'Demande envoyée au professionnel'],
];

const providerFlow = [
  ['4 USD', 'Par mois', 'Un abonnement accessible'],
  ['-15 %', 'Abonnement 6 mois', '20,40 USD au lieu de 24 USD'],
  ['-25 %', 'Abonnement 12 mois', '36 USD au lieu de 48 USD'],
];

const certificationDocuments = [
  ['Pièce d’identité', 'bi-person-vcard', 'Carte d’identité, permis de conduire ou passeport en cours de validité.'],
  ['Qualification', 'bi-mortarboard', 'Brevet, diplôme ou certificat attestant de votre métier.'],
];

const certificationBenefits = [
  ['Confiance renforcée', 'bi-shield-check', 'Les clients savent que votre identité et vos compétences ont été vérifiées.'],
  ['Profil mis en avant', 'bi-stars', 'Votre badge apparaît sur votre profil et dans les résultats de recherche.'],
  ['Plus de demandes', 'bi-graph-up-arrow', 'Les clients privilégient les prestataires certifiés pour leurs besoins.'],
  ['Image professionnelle', 'bi-award', 'Démarquez-vous de la concurrence avec un gage de sérieux reconnu.'],
];

const serviceCategories = [
  {
    title: 'Maison & Réparation',
    icon: 'bi-tools',
    image: serviceHomeRepairImage,
    examples: 'Plombier, électricien, réparateur, entretien maison',
    text: 'Trouvez un professionnel fiable pour intervenir vite à domicile, dans votre commune.',
  },
  {
    title: 'Transport & Livraison',
    icon: 'bi-truck',
    image: serviceTransportImage,
    examples: 'Chauffeur, taxi VIP, livraison rapide, déplacement urbain',
    text: 'Organisez vos déplacements et livraisons avec des prestataires proches et disponibles.',
  },
  {
    title: 'Beauté & Bien-être',
    icon: 'bi-flower1',
    image: serviceBeautyImage,
    examples: 'Coiffeur, maquilleur, soins personnels',
    text: 'Réservez des services personnels modernes, pratiques et accessibles depuis votre téléphone.',
  },
  {
    title: 'Services professionnels',
    icon: 'bi-person-workspace',
    image: serviceProfessionalImage,
    examples: 'Informaticien, consultant, assistance technique',
    text: 'Connectez-vous à des compétences utiles pour les particuliers, entreprises et institutions.',
  },
];

const reasons = [
  ['Rapidité', 'bi-speedometer2', 'Lancez une recherche et envoyez une demande sans perdre de temps.'],
  ['Simplicité', 'bi-hand-index-thumb', 'Un parcours clair pour les clients comme pour les prestataires.'],
  ['Confiance', 'bi-shield-check', 'Des profils visibles, comparables et faciles à contacter.'],
  ['Proximité', 'bi-geo', 'Des résultats pertinents selon la commune et la disponibilité.'],
  ['Professionnels disponibles', 'bi-person-workspace', 'Un espace dédié aux experts prêts à intervenir.'],
  ['Solution africaine', 'bi-globe2', 'Une plateforme pensée pour les réalités du marché local.'],
];

const mobileBenefits = [
  {
    title: 'Recherche intelligente',
    icon: 'bi-search',
    text: 'Trouvez facilement des prestataires selon votre besoin, votre localisation et leur disponibilité.',
  },
  {
    title: 'Profils et confiance',
    icon: 'bi-star-fill',
    text: 'Consultez les informations, évaluations et expériences avant de choisir.',
  },
  {
    title: 'Contact direct',
    icon: 'bi-chat-dots',
    text: 'Discutez avec les prestataires et organisez vos prestations simplement.',
  },
];

const testimonials = [
  {
    name: 'Patrick',
    role: 'Client',
    initials: 'P',
    text: "Grâce à Zwacop, j’ai trouvé rapidement un professionnel fiable pour mes besoins. Le service est simple et efficace.",
  },
  {
    name: 'Grâce',
    role: 'Prestataire',
    initials: 'G',
    text: "Zwacop m’aide à trouver de nouveaux clients et à développer mon activité comme prestataire.",
  },
  {
    name: 'Junior',
    role: 'Entrepreneur',
    initials: 'J',
    text: 'Une application adaptée aux réalités de Kinshasa. La mise en relation est rapide et sécurisée.',
  },
  {
    name: 'Sarah',
    role: 'Cliente',
    initials: 'S',
    text: "J’apprécie la facilité d’utilisation et la possibilité d’échanger directement avec les professionnels.",
  },
];

const urgentJourney = [
  {
    step: '01',
    title: 'Un problème apparaît',
    short: "Jean a besoin d'aide rapidement",
    icon: 'bi-droplet-half',
    visual: 'leak',
    bubble: 'Urgence plomberie détectée',
  },
  {
    step: '02',
    title: "Recherche d'un professionnel",
    short: 'ZWACOP trouve les bons professionnels près de vous',
    icon: 'bi-search',
    visual: 'map',
    bubble: '3 plombiers disponibles',
  },
  {
    step: '03',
    title: 'Connexion avec le prestataire',
    short: 'Emmanuel reçoit la mission en temps réel',
    icon: 'bi-bell',
    visual: 'notification',
    bubble: 'Nouvelle demande : fuite lavabo - Kinshasa',
  },
  {
    step: '04',
    title: 'Intervention rapide',
    short: 'Un service réalisé avec confiance',
    icon: 'bi-truck',
    visual: 'arrival',
    bubble: 'Prestataire en route',
  },
  {
    step: '05',
    title: 'Une nouvelle expérience digitale',
    short: 'ZWACOP rapproche ceux qui ont besoin d’aide et ceux qui offrent leurs compétences.',
    icon: 'bi-stars',
    visual: 'rating',
    bubble: 'Mission terminée',
  },
];

function JourneyVisual({ type }) {
  if (type === 'leak') {
    return (
      <div className="journey-scene leak-scene" aria-hidden="true">
        <div className="scene-person jean"><span>Jean</span><i className="bi bi-phone" /></div>
        <div className="sink-card">
          <i className="bi bi-water" />
          <span className="water-drop one" />
          <span className="water-drop two" />
          <span className="water-drop three" />
        </div>
        <div className="alert-bubble"><i className="bi bi-exclamation-circle" />Urgence plomberie détectée</div>
      </div>
    );
  }

  if (type === 'map') {
    return (
      <div className="journey-scene map-scene" aria-hidden="true">
        <div className="mini-app-panel">
          <div className="mini-search"><i className="bi bi-search" />Plomberie</div>
          <div className="map-grid">
            <span className="pin main" />
            <span className="pin second" />
            <span className="pin third" />
          </div>
          <div className="provider-mini-card">
            <span className="avatar">E</span>
            <div><strong>Emmanuel</strong><small>4.9 • Disponible • 1.8 km</small></div>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'notification') {
    return (
      <div className="journey-scene notify-scene" aria-hidden="true">
        <div className="scene-person emmanuel"><span>Emmanuel</span><i className="bi bi-tools" /></div>
        <div className="phone-notification">
          <i className="bi bi-bell-fill" />
          <div><strong>Nouvelle demande</strong><small>Réparation fuite lavabo - Kinshasa</small></div>
        </div>
      </div>
    );
  }

  if (type === 'arrival') {
    return (
      <div className="journey-scene arrival-scene" aria-hidden="true">
        <div className="route-line"><span className="vehicle"><i className="bi bi-car-front-fill" /></span></div>
        <div className="home-node"><i className="bi bi-house-check" />Jean</div>
        <div className="tool-node"><i className="bi bi-wrench-adjustable" />Réparation</div>
      </div>
    );
  }

  return (
    <div className="journey-scene rating-scene" aria-hidden="true">
      <div className="stars-row">
        <i className="bi bi-star-fill" />
        <i className="bi bi-star-fill" />
        <i className="bi bi-star-fill" />
        <i className="bi bi-star-fill" />
        <i className="bi bi-star-fill" />
      </div>
      <div className="community-card">
        <span className="avatar">J</span>
        <span className="avatar">E</span>
        <span className="avatar">ZW</span>
        <strong>Communauté active</strong>
      </div>
    </div>
  );
}

function StoreBadge({ type }) {
  const href = type === 'Google Play' ? playStoreUrl : appStoreUrl;

  return (
    <a className="store-badge" href={href} target="_blank" rel="noreferrer" aria-label={`Télécharger sur ${type}`}>
      <span className="store-symbol">
        <i className={`bi ${type === 'Google Play' ? 'bi-google-play' : 'bi-apple'}`} aria-hidden="true" />
      </span>
      <span>
        <small>{type === 'Google Play' ? 'Disponible sur' : 'Télécharger dans'}</small>
        {type}
      </span>
    </a>
  );
}

function PhoneMockup({ className = '', label = 'Capture d’écran ZWACOP', image = phoneShot }) {
  return (
    <div className={`phone-mockup ${className}`} aria-label={label}>
      <div className="phone-speaker" />
      <img src={image} alt={label} />
    </div>
  );
}

function App() {
  return (
    <div className="app-shell">
      <header className="hero" id="accueil">
        <nav className="nav">
          <a className="brand" href="#accueil" aria-label="Accueil ZWACOP">
            <img src={appIcon} alt="" />
            <span>ZWACOP</span>
          </a>
          <div className="nav-links">
            <a href="#fonctionnement">Fonctionnement</a>
            <a href="#clients">Clients</a>
            <a href="#prestataires">Prestataires</a>
            <a href="#certification">Certification</a>
            <a href="#contact">Contact</a>
          </div>
        </nav>

        <div className="hero-layout">
          <div className="hero-copy">
            <p className="eyebrow">Application mobile de services locaux</p>
            <h1>Trouvez le bon professionnel, au bon moment.</h1>
            <p className="hero-text">
              ZWACOP est l'application mobile qui connecte les clients aux prestataires de services qualifiés près de chez eux.
            </p>
            <div className="hero-actions">
              <a className="button primary" href={playStoreUrl} target="_blank" rel="noreferrer"><i className="bi bi-download" aria-hidden="true" />Télécharger l'application</a>
              <a className="button secondary" href="#prestataires"><i className="bi bi-briefcase" aria-hidden="true" />Devenir prestataire</a>
            </div>
            <div className="store-row" id="download">
              <StoreBadge type="Google Play" />
              <StoreBadge type="App Store" />
            </div>
          </div>

          <div className="hero-media">
            <div className="status-pill">Prestataires disponibles à Kinshasa</div>
            <PhoneMockup className="hero-phone" />
            <div className="floating-card top-card">
              <strong>3 résultats</strong>
              <span>par commune</span>
            </div>
            <div className="floating-card bottom-card">
              <strong>Demande envoyée</strong>
              <span>réponse directe</span>
            </div>
          </div>
        </div>
      </header>

      <main>
        <section className="section steps-section" id="fonctionnement">
          <div className="section-heading">
            <p className="eyebrow">Comment fonctionne ZWACOP</p>
            <h2>Une demande de service claire en trois étapes.</h2>
          </div>
          <div className="steps-grid">
            {steps.map((step) => (
              <article className="step-card" key={step.title}>
                <span><i className={`bi ${step.icon}`} aria-hidden="true" /></span>
                <small>{step.number}</small>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section story-section">
          <div className="story-copy">
            <p className="eyebrow">Exemple d'utilisation</p>
            <h2>Tony règle son problème de plomberie sans tourner en rond.</h2>
            <p>
              Tony a un problème de plomberie. Il ouvre ZWACOP, recherche un plombier disponible dans sa commune, consulte les profils et envoie une demande. Le prestataire accepte et intervient rapidement.
            </p>
          </div>
          <div className="story-phones">
            <PhoneMockup className="story-phone front" label="Recherche de prestataires ZWACOP" />
            <PhoneMockup className="story-phone rear" label="Profil prestataire ZWACOP" image={providerShot} />
          </div>
        </section>

        <section className="section audience-section" id="clients">
          <div className="section-heading audience-heading">
            <p className="eyebrow">Clients & prestataires</p>
            <h2>Deux parcours, une même plateforme de confiance pour les services en RDC.</h2>
            <p>
              À Kinshasa, trouver le bon professionnel ou se faire connaître peut prendre du temps. ZWACOP simplifie la rencontre entre la demande et le savoir-faire local.
            </p>
          </div>

          <div className="audience-grid">
            <article className="audience-card client-card">
              <div className="audience-topline">
                <span><i className="bi bi-house-heart" aria-hidden="true" /></span>
                <strong>Pour les clients</strong>
              </div>
              <h3>Trouvez rapidement un prestataire fiable près de chez vous.</h3>
              <p>
                Plus besoin de chercher au hasard. ZWACOP vous aide à comparer les profils, vérifier les compétences et contacter directement le professionnel disponible dans votre commune.
              </p>

              <div className="flow-list" aria-label="Parcours client">
                {clientFlow.map(([value, label, text]) => (
                  <div className="flow-item" key={label}>
                    <strong>{value}</strong>
                    <span>{label}</span>
                    <small>{text}</small>
                  </div>
                ))}
              </div>

              <div className="highlight-grid">
                {clientHighlights.map(([title, icon, text]) => (
                  <div className="highlight-item" key={title}>
                    <i className={`bi ${icon}`} aria-hidden="true" />
                    <div>
                      <strong>{title}</strong>
                      <span>{text}</span>
                    </div>
                  </div>
                ))}
              </div>

              <a className="button primary" href={playStoreUrl} target="_blank" rel="noreferrer">
                <i className="bi bi-search" aria-hidden="true" />
                Trouver un prestataire
              </a>
            </article>

            <article className="audience-card provider-card-premium" id="prestataires">
              <div className="audience-topline">
                <span><i className="bi bi-briefcase" aria-hidden="true" /></span>
                <strong>Pour les prestataires</strong>
              </div>
              <h3>Transformez votre savoir-faire en nouvelles opportunités.</h3>
              <p>
                Votre métier mérite d’être visible. Avec ZWACOP, créez un profil professionnel, recevez des demandes et développez vos revenus grâce au digital.
              </p>

              <div className="flow-list provider-flow" aria-label="Offre prestataire">
                {providerFlow.map(([value, label, text]) => (
                  <div className="flow-item" key={label}>
                    <strong>{value}</strong>
                    <span>{label}</span>
                    <small>{text}</small>
                  </div>
                ))}
              </div>

              <div className="highlight-grid">
                {providerHighlights.map(([title, icon, text]) => (
                  <div className="highlight-item" key={title}>
                    <i className={`bi ${icon}`} aria-hidden="true" />
                    <div>
                      <strong>{title}</strong>
                      <span>{text}</span>
                    </div>
                  </div>
                ))}
              </div>

              <a className="button secondary light" href="#contact">
                <i className="bi bi-person-plus" aria-hidden="true" />
                Devenir prestataire
              </a>
            </article>
          </div>
        </section>

        <section className="section certification-section" id="certification">
          <div className="certification-layout">
            <div className="certification-visual">
              <PhoneMockup
                className="certification-phone"
                label="Profil prestataire certifié dans l’application ZWACOP"
                image={certifiedBadgeShot}
              />
              <div className="certification-callout">
                <i className="bi bi-patch-check-fill" aria-hidden="true" />
                <div>
                  <strong>Profil certifié</strong>
                  <span>Le badge s’affiche à côté de votre nom</span>
                </div>
              </div>
            </div>

            <div className="certification-badge-card">
              <span className="certification-new">Nouveau</span>
              <div className="certification-seal" aria-hidden="true">
                <i className="bi bi-patch-check-fill" />
              </div>
              <p className="eyebrow">Badge de certification</p>
              <h2>Faites certifier votre profil prestataire.</h2>
              <p>
                Envoyez vos documents depuis l’application. Après vérification, un badge certifié s’affiche sur votre profil ZWACOP.
              </p>
              <div className="certification-price">
                <strong>5 USD</strong>
                <span>Frais de certification</span>
              </div>
              <div className="certification-documents" aria-label="Documents requis">
                {certificationDocuments.map(([title, icon, text]) => (
                  <div className="certification-document" key={title}>
                    <i className={`bi ${icon}`} aria-hidden="true" />
                    <div>
                      <strong>{title}</strong>
                      <span>{text}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="certification-benefits">
              <div className="section-heading compact">
                <p className="eyebrow">Les avantages</p>
                <h2>Un badge qui inspire confiance aux clients.</h2>
              </div>
              <div className="why-grid certification-grid">
                {certificationBenefits.map(([title, icon, text]) => (
                  <article className="why-card" key={title}>
                    <span><i className={`bi ${icon}`} aria-hidden="true" /></span>
                    <h3>{title}</h3>
                    <p>{text}</p>
                  </article>
                ))}
              </div>
              <a className="button primary" href="#contact">
                <i className="bi bi-patch-check" aria-hidden="true" />
                Obtenir mon badge
              </a>
            </div>
          </div>
        </section>

        <section className="section services-section">
          <div className="services-header">
            <div className="section-heading compact">
              <p className="eyebrow">Catégories de services</p>
              <h2>Un aperçu des services disponibles autour de vous.</h2>
            </div>
            <p>
              Zwacop rassemble les besoins du quotidien et les professionnels de confiance dans une expérience simple, rapide et adaptée à Kinshasa.
            </p>
          </div>

          <div className="services-visual-grid">
            <figure className="services-feature">
              <img src={urbanImpactImage} alt="Écosystème de services Zwacop dans une ville africaine moderne" />
              <figcaption>
                <span>Écosystème connecté</span>
                <strong>Des clients, des prestataires et des services rapides dans la même application.</strong>
              </figcaption>
            </figure>
            <div className="services-side-visuals">
              <img src={clientSearchImage} alt="Client utilisant Zwacop pour trouver un prestataire" />
              <img src={connectedProvidersImage} alt="Prestataires connectés via Zwacop" />
            </div>
          </div>

          <div className="services-grid">
            {serviceCategories.map((category) => (
              <article className="service-card" key={category.title}>
                <div className="service-image">
                  <img src={category.image} alt={`${category.title} sur Zwacop`} />
                </div>
                <div className="service-content">
                  <span><i className={`bi ${category.icon}`} aria-hidden="true" /></span>
                  <h3>{category.title}</h3>
                  <small>{category.examples}</small>
                  <p>{category.text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="section why-section">
          <div className="section-heading">
            <p className="eyebrow">Pourquoi choisir ZWACOP ?</p>
            <h2>Une plateforme fiable, rapide et proche du terrain.</h2>
          </div>
          <div className="why-grid">
            {reasons.map(([title, icon, text]) => (
              <article className="why-card" key={title}>
                <span><i className={`bi ${icon}`} aria-hidden="true" /></span>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section urgent-section">
          <div className="urgent-heading">
            <div>
              <p className="eyebrow">Scénario réel</p>
              <h2>Comment ZWACOP transforme une situation urgente en solution simple</h2>
            </div>
            <p>
              De la fuite sous le lavabo à l’intervention d’un plombier fiable, ZWACOP rend chaque étape plus claire, rapide et rassurante.
            </p>
          </div>

          <div className="urgent-stage">
            <div className="kinshasa-backdrop" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
            </div>
            <div className="journey-progress" aria-hidden="true">
              {urgentJourney.map((item) => (
                <span key={item.step} />
              ))}
            </div>
            <div className="journey-grid">
              {urgentJourney.map((item) => (
                <article className={`journey-card ${item.visual}`} key={item.step}>
                  <div className="journey-card-top">
                    <span className="journey-step">{item.step}</span>
                    <i className={`bi ${item.icon}`} aria-hidden="true" />
                  </div>
                  <JourneyVisual type={item.visual} />
                  <div className="journey-copy">
                    <strong>{item.title}</strong>
                    <p>{item.short}</p>
                  </div>
                  <div className="journey-bubble">{item.bubble}</div>
                </article>
              ))}
            </div>
          </div>

          <div className="urgent-final">
            <i className="bi bi-lightning-charge-fill" aria-hidden="true" />
            <strong>ZWACOP, la plateforme qui connecte les compétences congolaises aux besoins du quotidien.</strong>
          </div>
        </section>

        <section className="mobile-showcase" aria-label="Aperçu de l'application mobile ZWACOP">
          <div className="section mobile-app-layout">
            <div className="mobile-app-copy">
              <p className="eyebrow">Application mobile</p>
              <h2>Une application pensée pour simplifier vos services</h2>
              <p>
                Recherchez un prestataire, comparez les profils, échangez directement et trouvez rapidement la solution adaptée à vos besoins.
              </p>
              <a className="button primary" href={playStoreUrl} target="_blank" rel="noreferrer">
                <i className="bi bi-arrow-right-circle" aria-hidden="true" />
                Découvrir Zwacop
              </a>
            </div>

            <div className="mobile-app-phone-wrap">
              <PhoneMockup className="mobile-app-phone" label="Conversation directe dans l'application Zwacop" image={mobileAppImage} />
            </div>

            <div className="mobile-benefits">
              {mobileBenefits.map((benefit) => (
                <article className="mobile-benefit" key={benefit.title}>
                  <span><i className={`bi ${benefit.icon}`} aria-hidden="true" /></span>
                  <div>
                    <h3>{benefit.title}</h3>
                    <p>{benefit.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section testimonials-section">
          <div className="testimonials-heading">
            <p className="eyebrow">Témoignages</p>
            <h2>Ils nous font confiance</h2>
            <p>
              Zwacop rapproche les clients qui cherchent une solution rapide et les prestataires qui veulent valoriser leurs compétences.
            </p>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <article className="testimonial-card" key={testimonial.name}>
                <div className="testimonial-top">
                  <div className="testimonial-avatar">{testimonial.initials}</div>
                  <div>
                    <h3>{testimonial.name}</h3>
                    <span>{testimonial.role}</span>
                  </div>
                </div>
                <div className="testimonial-stars" aria-label="Note de 5 étoiles">
                  <i className="bi bi-star-fill" aria-hidden="true" />
                  <i className="bi bi-star-fill" aria-hidden="true" />
                  <i className="bi bi-star-fill" aria-hidden="true" />
                  <i className="bi bi-star-fill" aria-hidden="true" />
                  <i className="bi bi-star-fill" aria-hidden="true" />
                </div>
                <p>“{testimonial.text}”</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section contact-section" id="contact">
          <div className="contact-heading">
            <div>
              <p className="eyebrow">Contact</p>
              <h2>Besoin d'aide ? Parlons ensemble</h2>
              <p>
                Notre équipe est disponible pour répondre à vos questions, vous accompagner et vous aider à profiter pleinement de l'expérience Zwacop.
              </p>
            </div>
            <a className="whatsapp-float" href="https://wa.me/243838249020" target="_blank" rel="noreferrer">
              <i className="bi bi-whatsapp" aria-hidden="true" />
              Discuter avec Zwacop
            </a>
          </div>

          <div className="contact-layout">
            <form className="contact-form" action="mailto:jb@liviatech.store?subject=Contact%20ZWACOP" method="post" encType="text/plain">
              <div className="form-row">
                <label>
                  Nom complet
                  <input type="text" name="name" placeholder="Votre nom" />
                </label>
                <label>
                  Adresse email
                  <input type="email" name="email" placeholder="vous@email.com" />
                </label>
              </div>
              <div className="form-row">
                <label>
                  Numéro de téléphone
                  <input type="tel" name="phone" placeholder="+243 ..." />
                </label>
                <label>
                  Sujet de la demande
                  <input type="text" name="subject" placeholder="Téléchargement, compte, prestation..." />
                </label>
              </div>
              <label>
                Message
                <textarea name="message" rows="6" placeholder="Expliquez-nous comment nous pouvons vous aider." />
              </label>
              <button className="button primary" type="submit">
                <i className="bi bi-send" aria-hidden="true" />
                Envoyer mon message
              </button>
            </form>

            <aside className="contact-aside">
              <div className="quick-contact-grid">
                <a className="quick-contact-card" href="mailto:jb@liviatech.store?subject=Contact%20ZWACOP">
                  <span><i className="bi bi-envelope" aria-hidden="true" /></span>
                  <small>Email</small>
                  <strong>jb@liviatech.store</strong>
                </a>
                <a className="quick-contact-card" href="tel:+243838249020">
                  <span><i className="bi bi-telephone" aria-hidden="true" /></span>
                  <small>Téléphone</small>
                  <strong>+243 838 249 020</strong>
                </a>
                <a className="quick-contact-card" href="https://wa.me/243838249020" target="_blank" rel="noreferrer">
                  <span><i className="bi bi-whatsapp" aria-hidden="true" /></span>
                  <small>WhatsApp</small>
                  <strong>Réponse rapide</strong>
                </a>
                <div className="quick-contact-card">
                  <span><i className="bi bi-geo-alt" aria-hidden="true" /></span>
                  <small>Localisation</small>
                  <strong>Kinshasa, République Démocratique du Congo</strong>
                </div>
              </div>

              <div className="trust-note">
                <i className="bi bi-shield-check" aria-hidden="true" />
                <p>Votre satisfaction est notre priorité. L'équipe Zwacop vous accompagne à chaque étape.</p>
              </div>

              <div className="social-links" aria-label="Réseaux sociaux">
                <a href="https://wa.me/243838249020" target="_blank" rel="noreferrer" aria-label="WhatsApp"><i className="bi bi-whatsapp" aria-hidden="true" /></a>
                <a href="https://web.facebook.com/profile.php?id=61557155483448" target="_blank" rel="noreferrer" aria-label="Facebook"><i className="bi bi-facebook" aria-hidden="true" /></a>
                <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram"><i className="bi bi-instagram" aria-hidden="true" /></a>
                <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn"><i className="bi bi-linkedin" aria-hidden="true" /></a>
              </div>
            </aside>
          </div>
        </section>
      </main>

      <footer className="footer">
        <a href="#accueil">À propos de ZWACOP</a>
        <a href="#accueil">Politique de confidentialité</a>
        <a href="#accueil">Conditions d'utilisation</a>
        <a href="#contact">Contact</a>
        <a href={playStoreUrl} target="_blank" rel="noreferrer">Télécharger l'application</a>
      </footer>
    </div>
  );
}

export default App;
